import colors from "../../base/colors";

const { transparent, dark } = colors;

const textField = {
  styleOverrides: {
    root: {
      backgroundColor: transparent.main,
      color: dark.main,
    },
  },
};

export default textField;
